module.exports = __webpack_public_path__ + "img/recolumn2.3bdb2439.png";